<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0">
            {{ $yuyanbao.wodezhanghu }}
          </h1>
        </div>
      </div>
      <nav class="breadcrumb-nav">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>{{ $yuyanbao.wodezhanghu }}</li>
          </ul>
        </div>
      </nav>
      <div class="page-content pt-2">
        <div class="container">
          <div class="tab tab-vertical row gutter-lg">
            <ul class="nav nav-tabs mb-6" role="tablist">
              <li class="nav-item">
                <a href="#account-dashboard" class="nav-link active">
                  {{ $yuyanbao.wodezhanghu }}
                </a>
              </li>
              <li class="nav-item">
                <a href="#account-orders" class="nav-link">
                  {{ $yuyanbao.dingdan }}
                </a>
              </li>
              <li class="nav-item">
                <a href="#account-details" class="nav-link">
                  {{ $yuyanbao.zhanghuxiangqing }}
                </a>
              </li>
              <li class="nav-item">
                <a href="#account-passwords" class="nav-link">
                  {{ $yuyanbao.xiugaimima }}
                </a>
              </li>
              <li class="link-item">
                <a class="nav-link pointer" @click="zhu_xiao">
                  {{ $yuyanbao.zhuxiao }}
                </a>
              </li>
            </ul>

            <div class="tab-content mb-6">
              <div class="tab-pane active in" id="account-dashboard">
                <div class="row">
                  <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                    <a href="#account-orders" class="link-to-tab">
                      <div class="icon-box text-center">
                        <span class="icon-box-icon icon-orders">
                          <i class="w-icon-orders"></i>
                        </span>
                        <div class="icon-box-content">
                          <p class="text-uppercase mb-0">
                            {{ $yuyanbao.dingdan }}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                    <a href="#account-details" class="link-to-tab">
                      <div class="icon-box text-center">
                        <span class="icon-box-icon icon-account">
                          <i class="w-icon-user"></i>
                        </span>
                        <div class="icon-box-content">
                          <p class="text-uppercase mb-0">
                            {{ $yuyanbao.zhanghuxiangqing }}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                    <a href="#account-passwords" class="link-to-tab">
                      <div class="icon-box text-center">
                        <span class="icon-box-icon icon-download">
                          <i class="w-icon-download"></i>
                        </span>
                        <div class="icon-box-content">
                          <p class="text-uppercase mb-0">
                            {{ $yuyanbao.xiugaimima }}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                    <a href="javascript: void(0);" @click="zhu_xiao">
                      <div class="icon-box text-center">
                        <span class="icon-box-icon icon-logout">
                          <i class="w-icon-logout"></i>
                        </span>
                        <div class="icon-box-content">
                          <p class="text-uppercase mb-0">
                            {{ $yuyanbao.zhuxiao }}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              <div class="tab-pane mb-4" id="account-orders">
                <div class="icon-box icon-box-side icon-box-light">
                  <span class="icon-box-icon icon-orders">
                    <i class="w-icon-orders"></i>
                  </span>
                  <div class="icon-box-content">
                    <h4 class="icon-box-title text-capitalize ls-normal mb-0">
                      {{ $yuyanbao.dingdan }}
                    </h4>
                  </div>
                </div>

                <table class="shop-table account-orders-table mb-6">
                  <thead>
                    <tr>
                      <th class="order-id" style="text-align: left">
                        {{ $yuyanbao.dingdan }}
                      </th>
                      <th class="order-date" style="text-align: center">
                        {{ $yuyanbao.riqi }}
                      </th>
                      <th class="order-status" style="text-align: center">
                        {{ $yuyanbao.zhuangtai }}
                      </th>
                      <th class="order-total" style="text-align: center">
                        {{ $yuyanbao.zonge }}
                      </th>
                      <th class="order-actions"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in dingdan" :key="index">
                      <td class="order-id" style="text-align: left">
                        {{ item.dingdan }}
                        <span> - {{ item.ukey }}</span>
                      </td>
                      <td class="order-date" style="text-align: center">
                        {{ format_date(item.created, 1) }}
                      </td>
                      <td class="order-status" style="text-align: center">
                        {{ duoyuyan(item.zhuangtai) }}
                      </td>
                      <td class="order-total" style="text-align: center">
                        {{ item.zonge + $shezhi.huobi }}
                      </td>
                      <td class="order-action" style="text-align: right">
                        <span
                          class="btn btn-outline btn-default btn-block btn-sm btn-rounded"
                          @click="
                            $router.push({
                              path: '/receipt',
                              query: { ukey: item.ukey },
                            })
                          "
                        >
                          <i class="w-icon-orders"></i>
                        </span>
                      </td>
                    </tr>
                    <tr v-if="dingdan.length === 0">
                      <td
                        colspan="4"
                        style="text-align: center; line-height: 200px"
                      >
                        <kong></kong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="tab-pane" id="account-passwords">
                <div class="icon-box icon-box-side icon-box-light mb-8">
                  <span class="icon-box-icon icon-account mr-2">
                    <i class="w-icon-return3"></i>
                  </span>
                  <div class="icon-box-content">
                    <h4 class="icon-box-title mb-0 ls-normal">
                      {{ $yuyanbao.xiugaimima }}
                    </h4>
                  </div>
                </div>
                <div class="form account-details-form">
                  <div class="form-group">
                    <label class="text-dark" for="cur-password">
                      {{ $yuyanbao.jiumima }}
                    </label>
                    <input
                      type="password"
                      class="form-control form-control-md"
                      id="cur-password"
                      v-model="password.password"
                    />
                  </div>
                  <div class="form-group">
                    <label class="text-dark" for="new-password">
                      {{ $yuyanbao.xinmima }}
                    </label>
                    <input
                      type="password"
                      class="form-control form-control-md"
                      id="new-password"
                      v-model="password.newpassword"
                    />
                  </div>
                  <button
                    class="btn btn-dark btn-rounded btn-sm mb-4"
                    @click="put_password_http"
                    :disabled="passwordloading"
                  >
                    <div class="btn-text">
                      <i
                        class="w-icon-store-seo mr-1 xuanzhuan"
                        v-if="passwordloading"
                      ></i>
                      {{ $yuyanbao.baocun }}
                    </div>
                  </button>
                </div>
              </div>
              <div class="tab-pane" id="account-details">
                <div class="icon-box icon-box-side icon-box-light">
                  <span class="icon-box-icon icon-account mr-2">
                    <i class="w-icon-user"></i>
                  </span>
                  <div class="icon-box-content">
                    <h4 class="icon-box-title mb-0 ls-normal">
                      {{ $yuyanbao.xiangqing }}
                    </h4>
                  </div>
                </div>
                <form class="form account-details-form">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="firstname">{{ $yuyanbao.xing }} *</label>
                        <input
                          type="text"
                          id="firstname"
                          :placeholder="yonghu.xing"
                          v-model="detail.xing"
                          class="form-control form-control-md"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="lastname">{{ $yuyanbao.ming }} *</label>
                        <input
                          type="text"
                          id="lastname"
                          :placeholder="yonghu.ming"
                          v-model="detail.ming"
                          class="form-control form-control-md"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-3">
                    <label for="display-name">{{ $yuyanbao.nicheng }} *</label>
                    <input
                      type="text"
                      id="display-name"
                      :placeholder="yonghu.name"
                      v-model="detail.name"
                      class="form-control form-control-md mb-0"
                    />
                  </div>

                  <div class="form-group mb-6">
                    <label for="email_1">{{ $yuyanbao.youxiang }} *</label>
                    <input
                      type="email"
                      id="email_1"
                      :placeholder="yonghu.email"
                      v-model="detail.email"
                      class="form-control form-control-md"
                    />
                  </div>

                  <div class="form-group mb-6">
                    <label for="dianhua">{{ $yuyanbao.dianhua }} *</label>
                    <input
                      type="text"
                      id="dianhua"
                      :placeholder="yonghu.dianhua"
                      v-model="detail.dianhua"
                      class="form-control form-control-md"
                    />
                  </div>
                  <div class="form-group mb-6">
                    <label for="dizhi">{{ $yuyanbao.dizhi }} *</label>
                    <input
                      type="text"
                      id="dizhi"
                      :placeholder="yonghu.dizhi"
                      v-model="detail.dizhi"
                      class="form-control form-control-md"
                    />
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="codepostal"
                          >{{ $yuyanbao.codepostal }} *</label
                        >
                        <input
                          type="text"
                          id="codepostal"
                          :placeholder="yonghu.codepostal"
                          v-model="detail.codepostal"
                          class="form-control form-control-md"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="chengshi">{{ $yuyanbao.chengshi }} *</label>
                        <input
                          type="text"
                          id="chengshi"
                          :placeholder="yonghu.chengshi"
                          v-model="detail.chengshi"
                          class="form-control form-control-md"
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    class="btn btn-dark btn-rounded btn-sm mb-4"
                    @click="put_yonghu_http"
                    :disabled="detailloading"
                  >
                    <div class="btn-text">
                      <i
                        class="w-icon-store-seo mr-1 xuanzhuan"
                        v-if="detailloading"
                      ></i>
                      {{ $yuyanbao.baocun }}
                    </div>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { putYongHuPassword, putYongHu } from "@/api/yonghu";
import { getDingDan } from "@/api/dingdan";

export default {
  name: "Account",
  components: {},
  data() {
    return {
      yonghu: {},
      detail: {
        xing: "",
        ming: "",
        name: "",
        email: "",
        dianhua: "",
        dizhi: "",
        codepostal: "",
        chengshi: "",
      },
      password: {
        password: "",
        newpassword: "",
      },
      passwordloading: false,
      detailloading: false,
      dingdan: [],
    };
  },
  mounted() {
    this.yonghu = this.$store.state.yonghu;
    this.get_dingdan_http();
  },
  methods: {
    zhu_xiao() {
      this.$store.commit("logout");
      this.$router.push({ name: "Index" });
    },
    get_dingdan_http() {
      getDingDan({
        yonghu: this.yonghu.id,
      }).then((data) => {
        if (data.status === "SUCCESSED") this.dingdan = data.data;
      });
    },
    put_yonghu_http() {
      const { id } = this.yonghu;
      const { xing, ming, name, email, dianhua, dizhi, chengshi, codepostal } =
        this.detail;
      if (
        email !== "" &&
        !/^[\.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email)
      ) {
        this.toast({
          icon: "info",
          title: this.$yuyanbao.youxiang,
        });
        return;
      }
      if (this.detailloading) return;
      this.detailloading = true;
      setTimeout(() => {
        putYongHu({
          id,
          xing,
          ming,
          name,
          dianhua,
          email,
          dizhi,
          chengshi,
          codepostal,
        })
          .then((data) => {
            this.toast_http({ status: data.status });
            if (data.status === "SUCCESSED") {
              if (ming) this.yonghu.ming = ming;
              if (xing) this.yonghu.xing = xing;
              if (email) this.yonghu.email = email;
              if (dianhua) this.yonghu.dianhua = dianhua;
              if (name) this.yonghu.name = name;
              if (dizhi) this.yonghu.dizhi = dizhi;
              if (codepostal) this.yonghu.codepostal = codepostal;
              if (chengshi) this.yonghu.chengshi = chengshi;
              this.$store.commit("set_yonghu", this.yonghu);
            }
          })
          .finally(() => (this.detailloading = false));
      }, 500);
    },
    put_password_http() {
      if (this.password.password === "") {
        this.toast({
          icon: "info",
          title: this.$yuyanbao.jiumima,
        });
        return;
      }
      if (this.password.newpassword === "") {
        this.toast({
          icon: "info",
          title: this.$yuyanbao.xinmima,
        });
        return;
      }
      if (this.passwordloading) return;
      this.passwordloading = true;
      const { id } = this.yonghu;
      const { password, newpassword } = this.password;
      setTimeout(() => {
        putYongHuPassword({
          id,
          password,
          newpassword,
        })
          .then((data) => {
            this.toast_http({ status: data.status && data.data === 1 });
          })
          .finally(() => (this.passwordloading = false));
      }, 500);
    },
  },
};
</script>

<style scoped>
.btn-text {
  position: relative;
  display: inline-block;
  width: auto;
  padding: 0 25px;
}
</style>
